import { combineReducers } from 'redux';
import { ActionType } from './newsCategory4Actions';

const loading = (state = false, { type }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_4_REQUEST:
      return true;

    case ActionType.NEWS_CATEGORY_4_SUCCESS_UK:
    case ActionType.NEWS_CATEGORY_4_SUCCESS_RU:
    case ActionType.NEWS_CATEGORY_4_ERROR_UK:
    case ActionType.NEWS_CATEGORY_4_ERROR_RU:
      return false;

    default:
      return state;
  }
};

const newsCategory4UK = (state = [], { type, payload }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_4_SUCCESS_UK:
      return state.concat(payload);

    default:
      return state;
  }
};

const newsCategory4RU = (state = [], { type, payload }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_4_SUCCESS_RU:
      return state.concat(payload);

    default:
      return state;
  }
};

const newsCategory4ErrorUK = (state = null, { type, payload }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_4_ERROR_UK:
      return payload;

    case ActionType.NEWS_CATEGORY_4_REQUEST:
    case ActionType.NEWS_CATEGORY_4_SUCCESS_UK:
      return null;

    default:
      return state;
  }
};

const newsCategory4ErrorRU = (state = null, { type, payload }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_4_ERROR_RU:
      return payload;

    case ActionType.NEWS_CATEGORY_4_REQUEST:
    case ActionType.NEWS_CATEGORY_4_SUCCESS_RU:
      return null;

    default:
      return state;
  }
};

const newsCategory4PageNumberUK = (state = 1, { type }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_4_PAGE_NUMBER_UK:
      return state + 1;

    default:
      return state;
  }
};

const newsCategory4PageNumberRU = (state = 1, { type }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_4_PAGE_NUMBER_RU:
      return state + 1;

    default:
      return state;
  }
};

export default combineReducers({
  loading,
  newsCategory4UK,
  newsCategory4RU,
  newsCategory4ErrorUK,
  newsCategory4ErrorRU,
  newsCategory4PageNumberUK,
  newsCategory4PageNumberRU,
});
